/**
 **@Description:
 **@author: leo
 */

import config from 'crm/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    list: {
        url: `${authApi}/api/roles`,
        type: 'GET',
    },
    create: {
        url: `${authApi}/api/roles`,
        type: 'POST',
    },
    update: {
        url: `${authApi}/api/roles/{id}`,
        type: 'PUT',
    },
    remove: {
        url: `${authApi}/api/roles/{id}`,
        type: 'DELETE',
    },
}
